import PublicContracts from './views/public_contracts.c';
export default PublicContracts;
